
export interface ShapeDrawOptions {
    index?: number;
    drawMiddleMarkers?: boolean;
    
}

